import moment, {isMoment} from "moment";
moment.fn.toJSON = function() { return this.format(); }

export {isMoment}
export default moment